if (!customElements.get("quick-add-modal")) {
  customElements.define(
    "quick-add-modal",
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        this.quickViewProductData = null;
        this.quickViewInitialVariantId = null;
        this.quickViewUserChangedVariant = false;
        this.quickViewAbortController = null;
        this.quickViewCleanupObserver = null;

        window.addEventListener("keyup", (event) => {
          if (event.code.toUpperCase() === "ESCAPE") this.hide();
        });

        /*window.addEventListener('resize', function () {
					$('.js-media-list').each(function () {
						this.swiper?.destroy();
					});
					$('.js-media-sublist').each(function () {
						this.swiper?.destroy();
					});

					setTimeout(() => {
						subSliderInit(true);
						sliderInit(true);
					}, 200)
				});*/
      }

      hide(preventFocus = false) {
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer) cartDrawer.setActiveElement(this.openedBy);
        this.quickViewAbortController?.abort();
        this.quickViewAbortController = null;
        this.quickViewCleanupObserver?.disconnect();
        this.quickViewCleanupObserver = null;
        this.quickViewProductData = null;
        this.quickViewInitialVariantId = null;
        this.quickViewUserChangedVariant = false;
        this.modalContent.innerHTML = "";

        quickAddsliderInit(true, this);

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute("aria-disabled", true);
        opener.classList.add("loading");

        if (opener.querySelector(".loading-overlay__spinner")) {
          opener
            .querySelector(".loading-overlay__spinner")
            .classList.remove("hidden");
        }

        fetch(opener.getAttribute("data-product-url"))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.productElement = responseHTML.querySelector(
              'section[id^="MainProduct-"]'
            );
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(
              this.modalContent,
              this.productElement.innerHTML,
              opener
            );
            this.initQuickViewGallery();

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
            super.show(opener);
            this.setFocusElement(opener);
            this.startQuickViewCleanup();
            this.bindQuickViewInteractions();
            this.loadQuickViewProductData(opener);
          })
          .finally(() => {
            opener.removeAttribute("aria-disabled");
            opener.classList.remove("loading");

            if (opener.querySelector(".loading-overlay__spinner")) {
              opener
                .querySelector(".loading-overlay__spinner")
                .classList.add("hidden");
            }

            quickAddsliderInit(true, this);

            if (typeof window.initProductDropdownSelect === "function") {
              window.initProductDropdownSelect(this);
            }
          });
      }

      setInnerHTML(element, html, opener) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll("script").forEach((oldScriptTag) => {
          const newScriptTag = document.createElement("script");
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(
            document.createTextNode(oldScriptTag.innerHTML)
          );
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });

        const moreBtn = document.createElement("a");
        moreBtn.innerHTML = `
					<span>${theme.quickviewMore}</span>
					<svg
						class="icon icon-button-arrow"
						xmlns="http://www.w3.org/2000/svg"
						width="6"
						height="6"
						viewBox="0 0 6 6"
						fill="none"
					>
						<path d="M5 3L0.5 5.59808L0.5 0.401924L5 3Z" fill="currentColor"/>
					</svg>
				`;
        moreBtn.setAttribute("href", opener.getAttribute("data-product-url"));
        moreBtn.setAttribute(
          "class",
          "product__full-details button button--tertiary"
        );
        element
          .querySelector(".product .product__info-main_content")
          .appendChild(moreBtn);
      }

      removeDOMElements() {
        const modal = this.productElement.querySelector("product-modal");
        if (modal) modal.remove();

        const popup = this.productElement.querySelectorAll(".product-popup");
        if (popup)
          popup.forEach((el) => {
            el.remove();
          });

        const about = this.productElement.querySelectorAll(".about");
        if (about)
          about.forEach((el) => {
            el.remove();
          });

        const iconText = this.productElement.querySelectorAll(
          ".product__text-icon"
        );
        if (iconText)
          iconText.forEach((el) => {
            el.remove();
          });

        const additional_heading = this.productElement.querySelectorAll(
          ".additional_heading"
        );
        if (additional_heading)
          additional_heading.forEach((el) => {
            el.remove();
          });

        const additional_description = this.productElement.querySelectorAll(
          ".additional_description"
        );
        additional_description.forEach((el) => el.remove());

        const product__text =
          this.productElement.querySelectorAll(".product__text");
        if (product__text)
          product__text.forEach((el) => {
            el.remove();
          });

        const shareButtons =
          this.productElement.querySelector(".share-buttons");
        if (shareButtons) shareButtons.remove();

        const tags = this.productElement.querySelector(".product-tags");
        if (tags) tags.remove();

        const pickupAvailability = this.productElement.querySelector(
          ".pickup-availability"
        );
        if (pickupAvailability) pickupAvailability.remove();

        const description = this.productElement.querySelector(
          ".product__description"
        );
        if (description) description.remove();

        const recommendations = this.productElement.querySelectorAll(
          "product-recommendations, .product-recommendations, .complementary-products"
        );

        recommendations.forEach((el) => el.remove());

        this.productElement
          .querySelectorAll(
            '[class*="recommendation"], [id*="recommendation"], .complementary-products, .product-recommendations'
          )
          .forEach((el) => el.remove());

        this.productElement
          .querySelectorAll("h1, h2, h3, h4, h5, h6, .title, .heading")
          .forEach((heading) => {
            if ((heading.textContent || "").trim().toLowerCase().includes("you may also like")) {
              const container =
                heading.closest("product-recommendations, .product-recommendations, .complementary-products, section") ||
                heading;
              container.remove();
            }
          });

        const ticker = this.productElement.querySelector(".ticker");

        if (ticker) ticker.remove();

        const product__tags =
          this.productElement.querySelector(".product__tags");

        if (product__tags) product__tags.remove();

        const product__inventory = this.productElement.querySelector(
          ".product__inventory"
        );

        if (product__inventory) product__inventory.remove();

        const product__sku = this.productElement.querySelector(".product__sku");

        if (product__sku) product__sku.remove();

        const product_sticky_add_bar = this.productElement.querySelector(
          ".product-sticky-add-bar"
        );

        if (product_sticky_add_bar) product_sticky_add_bar.remove();

        const product__popup =
          this.productElement.querySelector(".product__popup");
        if (product__popup) product__popup.remove();

        // Keep title, price, badges and purchase controls in their native product-info column.
        // The centered quick-view layout is handled entirely with scoped CSS.
        const duplicateInfoContainers = this.productElement.querySelectorAll(
          ".product__info-container"
        );
        duplicateInfoContainers.forEach((container, index) => {
          if (index > 0) container.remove();
        });

        const productMain = this.productElement.querySelector(".product__main");
        const sourceImages = Array.from(
          this.productElement.querySelectorAll(
            ".product__media-item img, .product__media img"
          )
        );

        const uniqueImages = [];
        const seenSources = new Set();
        sourceImages.forEach((img) => {
          const src = img.currentSrc || img.src || img.getAttribute("src");
          if (!src || seenSources.has(src)) return;
          seenSources.add(src);
          uniqueImages.push(img);
        });

        if (productMain && uniqueImages.length) {
          const gallery = document.createElement("div");
          gallery.className = "quick-view-gallery";

          const stage = document.createElement("div");
          stage.className = "quick-view-gallery__stage";

          const mainImage = uniqueImages[0].cloneNode(true);
          mainImage.className = "quick-view-gallery__main-image";
          mainImage.removeAttribute("style");
          mainImage.removeAttribute("width");
          mainImage.removeAttribute("height");
          mainImage.loading = "eager";
          mainImage.decoding = "async";
          stage.appendChild(mainImage);
          gallery.appendChild(stage);

          if (uniqueImages.length > 1) {
            const thumbs = document.createElement("div");
            thumbs.className = "quick-view-gallery__thumbs";
            thumbs.setAttribute("role", "list");

            uniqueImages.slice(0, 5).forEach((img, index) => {
              const button = document.createElement("button");
              button.type = "button";
              button.className =
                "quick-view-gallery__thumb" + (index === 0 ? " is-active" : "");
              button.setAttribute("aria-label", `View product image ${index + 1}`);
              button.dataset.imageIndex = String(index);

              const thumbImg = img.cloneNode(true);
              thumbImg.removeAttribute("style");
              thumbImg.removeAttribute("width");
              thumbImg.removeAttribute("height");
              thumbImg.loading = "lazy";
              button.appendChild(thumbImg);
              thumbs.appendChild(button);
            });

            gallery.appendChild(thumbs);
          }

          productMain.innerHTML = "";
          productMain.appendChild(gallery);
        }
      }
      loadQuickViewProductData(opener) {
        const rawUrl = opener?.getAttribute("data-product-url");
        if (!rawUrl) return;

        const productUrl = new URL(rawUrl, window.location.origin);
        this.quickViewInitialVariantId = productUrl.searchParams.get("variant");
        this.quickViewUserChangedVariant = false;

        fetch(`${productUrl.pathname}.js`)
          .then((response) => {
            if (!response.ok) throw new Error("Quick View product data request failed");
            return response.json();
          })
          .then((productData) => {
            this.quickViewProductData = productData;
            this.syncQuickViewGalleryFromCurrentVariant();
          })
          .catch(() => {});
      }

      bindQuickViewInteractions() {
        this.quickViewAbortController?.abort();
        this.quickViewAbortController = new AbortController();
        const signal = this.quickViewAbortController.signal;

        this.modalContent.addEventListener(
          "click",
          (event) => {
            const thumb = event.target.closest(".quick-view-gallery__thumb");
            if (!thumb || !this.modalContent.contains(thumb)) return;

            event.preventDefault();
            event.stopPropagation();

            const mainImage = this.modalContent.querySelector(
              ".quick-view-gallery__main-image"
            );
            if (!mainImage) return;

            const src = thumb.dataset.quickViewSrc;
            if (src) {
              mainImage.src = src;
              mainImage.removeAttribute("srcset");
            }
            mainImage.alt = thumb.dataset.quickViewAlt || "";

            this.modalContent
              .querySelectorAll(".quick-view-gallery__thumb")
              .forEach((item) => item.classList.remove("is-active"));
            thumb.classList.add("is-active");
          },
          { signal }
        );

        this.modalContent.addEventListener(
          "change",
          (event) => {
            if (
              !event.target.closest(
                "variant-radios, variant-selects, .product-parameters, [data-option-position]"
              )
            ) return;

            this.quickViewUserChangedVariant = true;
            window.setTimeout(() => this.syncQuickViewGalleryFromCurrentVariant(), 80);
          },
          { signal }
        );
      }

      getQuickViewSelectedOptions() {
        const controls = Array.from(
          this.modalContent.querySelectorAll("[data-option-position]")
        );
        const valuesByPosition = new Map();

        controls.forEach((control) => {
          const position = Number(control.dataset.optionPosition || 0);
          if (!position || valuesByPosition.has(position)) return;
          const checked = control.querySelector(
            'input[type="radio"]:checked, input[type="checkbox"]:checked'
          );
          const select = control.querySelector("select");
          const value = checked?.value || select?.value || "";
          if (value) valuesByPosition.set(position, value);
        });

        return Array.from(valuesByPosition.entries())
          .sort((a, b) => a[0] - b[0])
          .map((entry) => entry[1]);
      }

      getQuickViewCurrentVariant() {
        const productData = this.quickViewProductData;
        if (!productData?.variants?.length) return null;

        if (!this.quickViewUserChangedVariant && this.quickViewInitialVariantId) {
          const initial = productData.variants.find(
            (variant) => String(variant.id) === String(this.quickViewInitialVariantId)
          );
          if (initial) return initial;
        }

        const selectedOptions = this.getQuickViewSelectedOptions();
        if (selectedOptions.length) {
          const match = productData.variants.find((variant) =>
            selectedOptions.every(
              (value, index) =>
                String(variant.options?.[index] || "") === String(value)
            )
          );
          if (match) return match;
        }

        return (
          productData.variants.find((variant) => variant.available) ||
          productData.variants[0]
        );
      }

      quickViewMediaSrc(media) {
        return (
          media?.preview_image?.src ||
          media?.preview_image?.url ||
          media?.src ||
          media?.url ||
          ""
        );
      }

      quickViewMediaCore(src) {
        if (!src) return "";
        try {
          const url = new URL(src, window.location.origin);
          const file = decodeURIComponent(url.pathname.split("/").pop() || "");
          return file
            .replace(/\.[a-z0-9]+$/i, "")
            .replace(/_[0-9]+x[0-9]*$/i, "")
            .split("_")[0];
        } catch (error) {
          return String(src)
            .split("?")[0]
            .split("/")
            .pop()
            .replace(/\.[a-z0-9]+$/i, "")
            .split("_")[0];
        }
      }

      quickViewMediaFamily(src) {
        return this.quickViewMediaCore(src).replace(
          /-(?:0?[1-9]|[1-9][0-9])$/i,
          ""
        );
      }

      getQuickViewMediaForVariant(variant) {
        const productData = this.quickViewProductData;
        const productMedia = (productData?.media || []).filter(
          (media) => !media.media_type || media.media_type === "image"
        );
        if (!productMedia.length) return [];

        const featuredId =
          variant?.featured_media?.id || variant?.featured_image?.id;
        const featuredMedia =
          productMedia.find(
            (media) => String(media.id) === String(featuredId)
          ) ||
          variant?.featured_media ||
          (variant?.featured_image
            ? { preview_image: variant.featured_image, alt: variant.featured_image.alt }
            : null);

        const featuredSrc = this.quickViewMediaSrc(featuredMedia);
        const family = this.quickViewMediaFamily(featuredSrc);

        let matches = family
          ? productMedia.filter(
              (media) =>
                this.quickViewMediaFamily(this.quickViewMediaSrc(media)) === family
            )
          : [];

        if (!matches.length && featuredMedia) matches = [featuredMedia];

        if (!matches.length) {
          const optionNames = (productData.options || []).map((option) =>
            String(option?.name || option || "").toLowerCase()
          );
          const colorIndex = optionNames.findIndex((name) =>
            name.includes("color")
          );
          const selectedColor =
            colorIndex >= 0 ? variant?.options?.[colorIndex] : "";
          if (selectedColor) {
            const colorText = String(selectedColor).toLowerCase();
            matches = productMedia.filter((media) =>
              String(media.alt || "").toLowerCase().includes(colorText)
            );
          }
        }

        const seen = new Set();
        const unique = matches.filter((media) => {
          const src = this.quickViewMediaSrc(media);
          if (!src || seen.has(src)) return false;
          seen.add(src);
          return true;
        });

        const viewPriority = [1, 5, 2, 3, 6, 7];
        unique.sort((a, b) => {
          const getView = (media) => {
            const core = this.quickViewMediaCore(this.quickViewMediaSrc(media));
            const match = core.match(/-([0-9]{1,2})$/);
            return match ? Number(match[1]) : 999;
          };
          const aView = getView(a);
          const bView = getView(b);
          const aRank = viewPriority.includes(aView)
            ? viewPriority.indexOf(aView)
            : 99 + aView;
          const bRank = viewPriority.includes(bView)
            ? viewPriority.indexOf(bView)
            : 99 + bView;
          return aRank - bRank;
        });

        return unique.slice(0, 7);
      }

      syncQuickViewGalleryFromCurrentVariant() {
        const variant = this.getQuickViewCurrentVariant();
        if (!variant) return;
        const media = this.getQuickViewMediaForVariant(variant);
        if (!media.length) return;

        const gallery = this.modalContent.querySelector(".quick-view-gallery");
        if (!gallery) return;
        const stage = gallery.querySelector(".quick-view-gallery__stage");
        if (!stage) return;

        const firstMedia = media[0];
        let mainImage = stage.querySelector(".quick-view-gallery__main-image");
        if (!mainImage) {
          mainImage = document.createElement("img");
          mainImage.className = "quick-view-gallery__main-image";
          stage.innerHTML = "";
          stage.appendChild(mainImage);
        }
        mainImage.src = this.quickViewMediaSrc(firstMedia);
        mainImage.alt = firstMedia.alt || this.quickViewProductData?.title || "";
        mainImage.removeAttribute("srcset");

        let thumbs = gallery.querySelector(".quick-view-gallery__thumbs");
        if (!thumbs) {
          thumbs = document.createElement("div");
          thumbs.className = "quick-view-gallery__thumbs";
          gallery.appendChild(thumbs);
        }
        thumbs.innerHTML = "";

        media.forEach((item, index) => {
          const src = this.quickViewMediaSrc(item);
          const button = document.createElement("button");
          button.type = "button";
          button.className =
            "quick-view-gallery__thumb" + (index === 0 ? " is-active" : "");
          button.dataset.quickViewSrc = src;
          button.dataset.quickViewAlt =
            item.alt || this.quickViewProductData?.title || "";
          button.setAttribute("aria-label", `View product image ${index + 1}`);

          const img = document.createElement("img");
          img.src = src;
          img.alt = item.alt || "";
          img.loading = "lazy";
          button.appendChild(img);
          thumbs.appendChild(button);
        });

        thumbs.hidden = media.length < 2;
      }

      cleanQuickViewRecommendationContent() {
        this.querySelectorAll(
          "product-recommendations, .product-recommendations, .complementary-products, [class*='recommendation'], [id*='recommendation']"
        ).forEach((element) => element.remove());

        this.querySelectorAll(
          "h1, h2, h3, h4, h5, h6, .title, .heading"
        ).forEach((heading) => {
          const text = (heading.textContent || "").trim().toLowerCase();
          if (
            !text.includes("you may also like") &&
            !text.includes("more to explore")
          ) return;

          const container =
            heading.closest(
              "product-recommendations, .product-recommendations, .complementary-products, section, .shopify-section"
            ) ||
            heading.parentElement ||
            heading;
          container.remove();
        });
      }

      startQuickViewCleanup() {
        this.cleanQuickViewRecommendationContent();
        this.quickViewCleanupObserver?.disconnect();
        this.quickViewCleanupObserver = new MutationObserver(() => {
          this.cleanQuickViewRecommendationContent();
        });
        this.quickViewCleanupObserver.observe(this, {
          childList: true,
          subtree: true,
        });
      }


      initQuickViewGallery() {
        const gallery = this.modalContent.querySelector(".quick-view-gallery");
        if (!gallery) return;

        const mainImage = gallery.querySelector(".quick-view-gallery__main-image");
        const thumbs = gallery.querySelectorAll(".quick-view-gallery__thumb");
        if (!mainImage || !thumbs.length) return;

        thumbs.forEach((thumb) => {
          thumb.addEventListener("click", () => {
            const img = thumb.querySelector("img");
            if (!img) return;

            const src = img.currentSrc || img.src || img.getAttribute("src");
            if (src) mainImage.src = src;
            if (img.srcset) mainImage.srcset = img.srcset;
            if (img.alt) mainImage.alt = img.alt;

            thumbs.forEach((item) => item.classList.remove("is-active"));
            thumb.classList.add("is-active");
          });
        });
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML =
          this.productElement.innerHTML.replaceAll(
            sectionId,
            `quickadd-${sectionId}`
          );
        this.productElement
          .querySelectorAll("variant-selects, variant-radios")
          .forEach((variantSelect) => {
            variantSelect.dataset.originalSection = sectionId;
          });
      }

      preventVariantURLSwitching() {
        if (this.modalContent.querySelector("variant-radios,variant-selects")) {
          this.modalContent
            .querySelector("variant-radios,variant-selects")
            .setAttribute("data-update-url", "false");
        }
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector(
          '[id^="Slider-Gallery"]'
        );
        if (!galleryList) return;

        galleryList.setAttribute("role", "presentation");
        galleryList
          .querySelectorAll('[id^="Slide-"]')
          .forEach((li) => li.setAttribute("role", "presentation"));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector(".product");
        const desktopColumns = product.classList.contains("product--columns");
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll(".product__media img");
        if (!mediaImages.length) return;

        let mediaImageSizes =
          "(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";

        if (product.classList.contains("product--medium")) {
          mediaImageSizes = mediaImageSizes.replace("715px", "605px");
        } else if (product.classList.contains("product--small")) {
          mediaImageSizes = mediaImageSizes.replace("715px", "495px");
        }

        mediaImages.forEach((img) =>
          img.setAttribute("sizes", mediaImageSizes)
        );
      }

      setFocusElement(opener) {
        const productCard = opener.closest(".card-wrapper");
        const productCardLink = productCard?.querySelector(
          ".card-wrapper__link--overlay"
        );

        if (productCardLink) this.openedBy = productCardLink;
      }
    }
  );
}
